module.exports = __webpack_public_path__ + "img/recorder.5b0ef645.png";